import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BackgroundImageStyles from './BackgroundImgStyles-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { getCdnImage } from '../../../utils/ImageManager';
import config from '../../../config';
import i18nMessages from '../../../constants/messages/pt-BR';

class BannerBackgroundImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: i18nMessages.desktop,
    };
  }
  componentDidMount() {
    window.addEventListener(i18nMessages.resize, this.handleWindowSizeChange);
    this.handleWindowSizeChange();
  }
  componentWillUnmount() {
    window.removeEventListener(
      i18nMessages.resize,
      this.handleWindowSizeChange
    );
  }
  handleWindowSizeChange = () => {
    if (window.innerWidth < config.screenWidth.tabWidthStart) {
      this.setState({ device: i18nMessages.mobile });
    } else if (
      window.innerWidth >= config.screenWidth.tabWidthStart &&
      window.innerWidth <= config.screenWidth.tabPhoneWidthEnd
    ) {
      this.setState({ device: i18nMessages.tablet });
    } else {
      this.setState({ device: i18nMessages.desktop });
    }
  };

  render() {
    const { data, id } = this.props;
    const { device } = this.state;
    const widthClass = getWidth(data.componentWidth);
    let stylesBack = data.styles;

    let backgroundStyle = BackgroundImageStyles[i18nMessages.backgrounddefault];
    if (stylesBack && BackgroundImageStyles[stylesBack.trim()] !== undefined) {
      backgroundStyle = BackgroundImageStyles[stylesBack.trim()];
    }
    let desktopURL = {},
      smartphoneURL = {},
      tabletURL = {};
    desktopURL = {
      backgroundImage: `url(${getCdnImage(
        data && data.desktopImage && data.desktopImage.url
      ,{ w: 2000, fm: 'webp' })})`,
      backgroundSize: 'cover',
    };
    smartphoneURL = {
      backgroundImage: `url(${getCdnImage(
        data && data.smartphoneImage && data.smartphoneImage.url
      , { w: 2000, fm: 'webp' })})`,
      backgroundSize: 'cover',
    };
    tabletURL = {
      backgroundImage: `url(${getCdnImage(
        data && data.tabletImage && data.tabletImage.url
      ,{ w: 2000, fm: 'webp' })})`,
      backgroundSize: 'cover',
    };
    switch (device) {
      case i18nMessages.mobile:
        return (
          <div
            className={classNames(widthClass, backgroundStyle)}
            style={smartphoneURL}
            alt={data.altText && data.altText}
            id={id}
          />
        );
      case i18nMessages.tablet:
        return (
          <div
            className={classNames(widthClass, backgroundStyle)}
            style={
              data && data.tabletImage && data.tabletImage.url
                ? tabletURL
                : desktopURL
            }
            alt={data.altText && data.altText}
            id={id}
          />
        );
      default:
        return (
          <div
            className={classNames(widthClass, backgroundStyle)}
            style={desktopURL}
            alt={data.altText && data.altText}
            id={id}
          >
            <img  alt={data.altText} src={getCdnImage(
        data && data.desktopImage && data.desktopImage.url
      ,{ w: 2000, fm: 'webp' })} style={{ display: 'none'}} />
          </div>
        );
    }
  }
}

BannerBackgroundImage.propTypes = {
  id: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  data: PropTypes.oneOfType([PropTypes.object]),
};

BannerBackgroundImage.defaultProps = {
  id: null,
  data: null,
};

export default BannerBackgroundImage;
